/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { StyleSheet, View, Dimensions } from 'react-native';
import PropTypes from 'prop-types';
import Colors from '@global/colors';

const fullWidth = Dimensions.get('window').width;

/**
 * Section separator. The defaults are the original thick grey band used between list sections;
 * pass `height` and `color` for a hairline rule, and `fullBleed={false}` to stay inside a padded
 * parent instead of spanning the whole window.
 */
const Divider = ({ height, color, fullBleed }) => {
  return (
    <View
      style={[
        styles.divider,
        { height, backgroundColor: color },
        fullBleed ? styles.fullBleed : styles.contained,
      ]}
    />
  );
};

Divider.propTypes = {
  height: PropTypes.number,
  color: PropTypes.string,
  fullBleed: PropTypes.bool,
};

Divider.defaultProps = {
  height: 10,
  color: Colors.grey5,
  fullBleed: true,
};

const styles = StyleSheet.create({
  // Measured once at module load, so it does not follow a browser resize. Kept as the default
  // for the existing callers that rely on the band spanning the window.
  fullBleed: { width: fullWidth },
  contained: { width: '100%' },
  divider: {},
});

export default Divider;
